/**
 * Avalara © 2018
 * file: engines/opus_ui/src/helpers/biztechQueries.js
 */

//I ripped a lot of this code out from the back end fairly quickly. It migh be worth it to spend some time refactoing and cleaning this file up.

import axios from 'axios';
import config from '../config';
// import jwtDecode from 'jwt-decode';
import { getBaseUrlFromConfig } from '../utils/url_helpers';
import { finishedLoadingNewTopCard } from '../actions/search';
// import { GraphQLClient } from 'graphql-request';
// import { getJwt } from '../utils/store';

export const baseUrl = getBaseUrlFromConfig(config.biztechApi);

const deliverySystems = [
  { name: 'avatax', path: 'avatax' },
  { name: 'avataxSandbox', path: 'avatax-sandbox' }
];

// Helper function to make delivery search requests - moved from provisioning service
function makeDeliverySearchRequest({ query, deliverySystemPath }) {
  const url = `${baseUrl}/delivery/${deliverySystemPath}/search?query=${query}`;
  return axios
    .get(url)
    .then(res => res.data.data)
    .catch(() => {
      // handle errors with empty array result
      console.error(`unable to complete query: ${url}`);
      return [];
    });
}

// Search delivery systems function - moved from provisioning service
function searchDeliverySystems({ query }) {
  const specialCaseAvataxIdCompare = /P(\d{10})/i.exec(query);
  const specialCaseSandboxIdCompare = /D(\d{10})/i.exec(query);
  const enhancedQuery =
    specialCaseAvataxIdCompare && specialCaseAvataxIdCompare[1]
      ? `avatax:${specialCaseAvataxIdCompare[1]}`
      : specialCaseSandboxIdCompare && specialCaseSandboxIdCompare[1]
      ? `avataxSandbox:${specialCaseSandboxIdCompare[1]}`
      : query;

  const systemNameSearch = new RegExp(
    '^(' + deliverySystems.map(system => system.name).join('|') + '):(.*)'
  ).exec(enhancedQuery);
  const systemNameToQuery = systemNameSearch && systemNameSearch[1];
  const queryString = systemNameToQuery ? systemNameSearch[2] : query;

  const applicableSystems = deliverySystems.filter(
    system => !systemNameToQuery | (systemNameToQuery == system.name)
  );
  return (
    Promise.all(
      applicableSystems.map(system =>
        makeDeliverySearchRequest({
          query: queryString,
          deliverySystemPath: system.path
        })
      )
    )
      // concat and flatten search results from each delivery system
      .then(results =>
        results.reduce((r, v) => r.concat(v), []).filter(results => results)
      )
  );
}

//TODO add billing, businessActivity
export const queryClasses = {
  customer: {
    initialQuery: (query) => {
      const url = `${baseUrl}/customer/search?query=${query}`;
      return queryComponent(url).then((results) => {
        let summary = [];

        const cancellationQueryIndex = results.indexOf('isCancellationQuery');
        if (cancellationQueryIndex !== -1) {
          summary = results
            .filter((c) => c)
            .filter((c) => c !== 'isCancellationQuery')
            .map((c) => ({
              type: 'caseSummary',
              data: c,
            }));
          return summary;
        }
        results.forEach((customer) => {
          // customer engine seems to return [null] when no results found
          if (customer === null) return;

          summary.push({ type: 'customerSummary', data: customer });
          customer.deliverySystemAccounts &&
            customer.deliverySystemAccounts.forEach(
              (deliverySystemReference) => {
                summary.push({
                  type: 'deliverySystemReference',
                  data: {
                    ...deliverySystemReference,
                    customerName: customer.name,
                  },
                });
              }
            );
          customer.contacts &&
            customer.contacts.forEach((contactReference) => {
              summary.push({
                type: 'contactReference',
                data: {
                  ...contactReference,
                  customerAccountId: customer.id,
                  customerName: customer.name,
                },
              });
            });
        });
        return summary;
      });
    },
  },
  delivery: {
    initialQuery: (query) => {
      // Call delivery systems directly instead of going through provisioning route
      return searchDeliverySystems({ query }).then((results) => {
        let summary = [];
        results.forEach((resultItem) => {
          if (
            resultItem.type === 'deliverySystemSummary' ||
            resultItem.type === 'businessLicensesSummary'
          ) {
            summary.push(resultItem);
            resultItem.data.customerAccount &&
              resultItem.data.customerAccount.id &&
              summary.push({
                type: 'customerReference',
                data: {
                  id: resultItem.data.customerAccount.id,
                  name: resultItem.data.customerAccount.name,
                },
              });
            resultItem.data.details &&
              resultItem.data.details.users &&
              resultItem.data.details.users.forEach((userReference) => {
                summary.push({
                  type: 'userReference',
                  data: { ...userReference },
                });
              });
          }
        });

        return Promise.resolve(summary);
      });
    },
  },
  // product: {
  //   initialQuery: (query) => {
  //     const url = `${baseUrl}/product/search?query=${query}`;
  //     return queryComponent(url).then((results) => {
  //       const summary = results.map((product) => {
  //         return { type: 'productSummary', data: product };
  //       });
  //       return summary;
  //     });
  //   },
  // },
};

export function queryComponent(url) {
  return axios
    .get(url)
    .then((res) => {
      if (res.data && res.data.data) {
        return res.data.data;
      } else {
        return [];
      }
    })
    .catch((ex) => {
      // console.error(`unable to api request: ${url}`, ex.message, ex.stack);
    });
}

export function rankResults(query, caseUrlParam, results) {
  const card = results.find((result) => {
    if (!resultTypes[result.type] || !resultTypes[result.type].keyCompare) {
      // console.error('keyCompare missing for : ', result);
    }
    return (
      resultTypes[result.type] &&
      resultTypes[result.type].keyCompare &&
      resultTypes[result.type].keyCompare(query, result)
    );
  });

  let sortedResults = results
    .map((wrapper) => {
      if (!resultTypes[wrapper.type] || !resultTypes[wrapper.type].createLink) {
        // console.error('createLink missing for : ', wrapper);
        return { deleteMe: true };
      } else {
        return resultTypes[wrapper.type].createLink(wrapper);
      }
    })
    .filter((w) => !w.deleteMe);

  if (card) {
    let createCardFunction = resultTypes[card.type].getCreateCardFunction(
      card,
      caseUrlParam
    );
    sortedResults = [
      { type: 'loadingCard', data: { createCardFunction, type: card.type } },
      ...sortedResults,
    ];
  }
  return sortedResults;
}

function concatenateEntitlements(featureDetailId){
    let entitlementsString=''
    for (var key of Object.keys(featureDetailId)) {      
      const services=featureDetailId[key].map(serviceObj=>serviceObj.avataxServiceName)
      entitlementsString += `${key}(${services.join(',')}) ` 
    }
    return entitlementsString;
}

const resultTypes = {
  customerSummary: {
    keyCompare: (query, wrapper) => {
      if (wrapper.data && (wrapper.data.id || wrapper.data.name)) {
        return (
          query === wrapper.data.id ||
          query.substring(0, 14) === wrapper.data.id.substring(0, 14) ||
          query.toLowerCase() === wrapper.data.name.toLowerCase() ||
          wrapper.data.name.toLowerCase().includes(query.toLowerCase())
        );
      } else {
        return false;
      }
    },
    createLink: (wrapper) => {
      return { type: 'customerLink', data: wrapper.data };
    },
    getCreateCardFunction: (wrapper, caseUrlParam) => {
      return (dispatch) => {
        let obligationSummaries = [];
        let transactionSummaries = [];
        let cancellationDetails = [];
        let deliverySystemDataSubscriptions = [];
        let usageGraphQLData = {};
        let isAuth = false;

        // const isAuth = isAuthorized();
        const casesUrl = `${baseUrl}/customer/customer-accounts/${wrapper.data.id}/cases`;

        return Promise.all([
          getCancellationProducts(casesUrl, caseUrlParam),
          {obligations: []}, // Removed business activity package
          [], // Removed business activity package
          // getUsageGraphQLData(wrapper.data.id),
          getDeliverySystemDataSubscriptions(
            wrapper.data.deliverySystemAccounts
          ),
          isAuthorizedToSeeCancelledProducts(),
        ]).then((results) => {
          isAuth = results[4];
          deliverySystemDataSubscriptions = results[3];
          usageGraphQLData = results[3];
          cancellationDetails = results[0];
          obligationSummaries = results[1].obligations
            .filter((o) => o.featureDetail && o.featureDetail.feature)
            .map((obligation) => {
              const accessStart = new Date(
                obligation.accessStart.replace(/-/g, '/').replace(/T.+/, '')
              );
              const termStart = new Date(
                obligation.termStart.replace(/-/g, '/').replace(/T.+/, '')
              );
              const termEnd = new Date(
                obligation.termEnd.replace(/-/g, '/').replace(/T.+/, '')
              );
              let toBeCancelled = false;
              if (isAuth) {
                toBeCancelled = cancellationDetails.mappedProducts.includes(
                  obligation.featureDetail.feature.productName
                );
              }
              return {
                itemId: obligation.id,
                transactionId: obligation.transactionId,
                externalId: obligation.externalId,
                quantity: obligation.quantity,
                featureDetail: obligation.featureDetail,
                cpqId: obligation.cpqId,
                endOfAgreementBehavior: obligation.endOfAgreementBehavior,
                accessStart: `${accessStart.toLocaleDateString('en-US')}`,
                termStart: `${termStart.toLocaleDateString('en-US')}`,
                termEnd: `${termEnd.toLocaleDateString('en-US')}`,
                createdAt: obligation.createdAt,
                customer: {
                  id: wrapper.data.id,
                  name: wrapper.data.name,
                },
                discountedExtendedAmount: obligation.discountedExtendedAmount,
                billingFrequency: obligation.billingFrequency,
                showToBeCancelled: toBeCancelled,
                connectorId: obligation.connectorId,
                connectorMarketplaceName: obligation.connectorMarketplaceName,
                connectorName: obligation.connectorName,
                connectorLevel: obligation.connectorLevel,
                connectorPOS: obligation.connectorPOS ? `Yes` : 'No',
              };
            });

          const featureDetailIds = obligationSummaries.map(
            (o) => o.featureDetail.id
          );
          
          let featureServiceRelationshipAPIpromise;
          // TODO this is bad. this is a 3rd round trip to the server.
          if (featureDetailIds.length > 0) {
            const featureServiceRelationshipUrl = `${baseUrl}/delivery/feature-service-relationships?featureDetailIds=${featureDetailIds.join(
              ','
            )}`;
            featureServiceRelationshipAPIpromise = queryComponent(
              featureServiceRelationshipUrl
            ).then((results) => {              
              let featureDetailIdLookUpHash = {};
              results.forEach((fsr) => {                
                if(!featureDetailIdLookUpHash[fsr.featureDetailId]){
                  featureDetailIdLookUpHash[fsr.featureDetailId]={}                  
                }
                if(!featureDetailIdLookUpHash[fsr.featureDetailId][fsr.deliverySystemSubtype]){
                  featureDetailIdLookUpHash[fsr.featureDetailId][
                    fsr.deliverySystemSubtype
                  ]=[]
                }
                  featureDetailIdLookUpHash[
                    fsr.featureDetailId
                  ][fsr.deliverySystemSubtype].push({avataxServiceId:fsr.avataxServiceId,avataxServiceName:fsr.avataxServiceName});                                           
              });
              obligationSummaries.forEach(
                o =>                  
                    {if(featureDetailIdLookUpHash[o.featureDetail.id]){
                      o.servicesTypeAndId= featureDetailIdLookUpHash[o.featureDetail.id]
                      o.featureServiceRelationship=concatenateEntitlements(featureDetailIdLookUpHash[o.featureDetail.id])
                    }else{
                      o.featureServiceRelationship= 'unknown'
                    }}
              )                    
            });            
          } else {
            featureServiceRelationshipAPIpromise = Promise.resolve({});
          }
          featureServiceRelationshipAPIpromise.then(() => {
            transactionSummaries = results[2].map((transaction) => {
              const effectiveFrom = new Date(transaction.effectiveFrom);

              return {
                id: transaction.id,
                type: transaction.type,
                effectiveFrom: effectiveFrom,
                externalId: transaction.externalId,
                customer: {
                  id: wrapper.data.id,
                  name: wrapper.data.name,
                },
              };
            });

            finishedLoadingNewTopCard(dispatch, {
              type: 'customerCard',
              data: {
                id: wrapper.data.id,
                name: wrapper.data.name,
                isActive: wrapper.data.isActive,
                createdAt: wrapper.data.createdAt,
                supportLevel: wrapper.data.supportLevel,
                camName: wrapper.data.camName,
                camId: wrapper.data.camId,
                camOwned: wrapper.data.camOwned,
                primaryContactName: wrapper.data.primaryContactName,
                primaryContactEmail: wrapper.data.primaryContactEmail,
                primaryContactId: wrapper.data.primaryContactId,
                isCupUser: wrapper.data.isCupUser,
                accountState: wrapper.data.accountState,
                zuoraAutopay: wrapper.data.zuoraAutopay,
                transactionSummaries: transactionSummaries,
                obligationSummaries: obligationSummaries,
                usageGraphQLData: usageGraphQLData,
                deliverySystemDataSubscriptions:
                  deliverySystemDataSubscriptions,
                invoiceSummaries: [],
                deliverySystemAccountSummaries: [
                  ...wrapper.data.deliverySystemAccounts.map(
                    (deliverySystem) => {
                      return {
                        customer: {
                          id: wrapper.data.id,
                          name: wrapper.data.name,
                        },
                        id: deliverySystem.id,
                        deliverySystem: deliverySystem.subtype,
                        createdAt:deliverySystem.createdAt,
                        modifiedAt:deliverySystem.modifiedAt,
                      };
                    }
                  ),
                ],
                billingAccountSummaries: [
                  ...wrapper.data.billingAccounts.map((billingAccount) => {
                    return {
                      customer: {
                        id: wrapper.data.id,
                        name: wrapper.data.name,
                      },
                      id: billingAccount.id,
                      accountNumber: billingAccount.accountNumber,
                      autoPay: billingAccount.autoPay,
                      defaultPaymentMethodId:
                        billingAccount.defaultPaymentMethodId,
                      billingContact: billingAccount.billingContact,
                    };
                  }),
                ],
                otherComments: cancellationDetails.comment,
                lastModifiedBy: cancellationDetails.lastModifiedBy,
              },
            });
          });
        });
      };
    },
  },
  customerReference: {
    keyCompare: (/*query, wrapper*/) => {
      return false; // never turn references into cards
    },
    createLink: (wrapper) => {
      return {
        type: 'customerLink',
        data: {
          id: wrapper.data.id,
          name: wrapper.data.name,
          isActive: wrapper.data.isActive,
        },
      };
    },
  },
  deliverySystemSummary: {
    keyCompare: (query, wrapper) => {
      return (
        query === wrapper.data.id ||
        query === `${wrapper.data.deliverySystem}:${wrapper.data.id}` ||
        query.substring(1) === wrapper.data.id
      );
    },
    createLink: (wrapper) => {
      if (wrapper.data && wrapper.data.id && wrapper.data.deliverySystem) {
        return {
          type: 'deliverySystemLink',
          data: {
            customer: {
              id: wrapper.data.customerAccount
                ? wrapper.data.customerAccount.id
                : 'No customer found',
              name: wrapper.data.customerAccount
                ? wrapper.data.customerAccount.name
                : 'No customer found',
            },
            id: wrapper.data.id,
            deliverySystem: wrapper.data.deliverySystem,
          },
        };
      } else {
        return false;
      }
    },
    getCreateCardFunction: (wrapper) => {
      return (dispatch) =>
        finishedLoadingNewTopCard(dispatch, {
          type: 'deliverySystemCard',
          data: wrapper.data,
        });
    },
  },
  deliverySystemReference: {
    keyCompare: (/*query, wrapper*/) => {
      return false; // never turn references into cards.
    },
    createLink: (wrapper) => {
      if (wrapper.data && wrapper.data.id && wrapper.data.subtype) {
        return {
          type: 'deliverySystemLink',
          data: {
            customer: {
              id: wrapper.data.customerAccount
                ? wrapper.data.customerAccount.id
                : 'No customer found',
              name: wrapper.data.customerAccount
                ? wrapper.data.customerAccount.name
                : 'No customer found',
            },
            id: wrapper.data.id,
            deliverySystem: wrapper.data.subtype,
          },
        };
      } else {
        return false;
      }
    },
  },
  contactReference: {
    keyCompare: (query, wrapper) => {
      return query === wrapper.data.id || query === wrapper.data.email;
    },
    createLink: (wrapper) => {
      return {
        type: 'contactLink',
        data: {
          customer: {
            id: wrapper.data.customerAccountId,
            name: wrapper.data.customerName,
          },
          id: wrapper.data.id,
          name: `${wrapper.data.firstName} ${wrapper.data.lastName}`,
          email: wrapper.data.email,
          onlineAuthorized: wrapper.data.onlineAuthorized,
        },
      };
    },
  },
  userReference: {
    keyCompare: (query, wrapper) => {
      return (
        query === wrapper.data.id ||
        query === wrapper.data.email ||
        query === wrapper.data.userName ||
        query === `${wrapper.data.firstName} ${wrapper.data.lastName}`
      );
    },
    createLink: (wrapper) => {
      return {
        type: 'userLink',
        data: {
          deliverySystemAccountId: wrapper.data.accountId,
          userName: wrapper.data.userName,
          name: `${wrapper.data.firstName} ${wrapper.data.lastName}`,
          email: wrapper.data.email,
          createdDate: new Date(wrapper.data.createdDate).toLocaleDateString(
            'en-US'
          ),
        },
      };
    },
  },
  invoiceSummary: {
    keyCompare: (/* query, wrapper */) => {
      return false;
    },
    createLink: (wrapper) => {
      return { type: 'invoiceLink', data: wrapper.data };
    },
  },
  transactionSummary: {
    keyCompare: (/* query, wrapper */) => {
      return false;
    },
    createLink: (wrapper) => {
      return { type: 'transactionLink', data: wrapper.data };
    },
  },
  caseSummary: {
    keyCompare: (/* query, wrapper */) => {
      return false;
    },
    createLink: (wrapper) => {
      return {
        type: 'caseLink',
        data: {
          customer: {
            id: wrapper.data.customerAccountId,
            name: wrapper.data.customerAccountName,
          },
          id: wrapper.data.id,
          caseNumber: wrapper.data.caseNumber,
          status: wrapper.data.status,
          ownerId: wrapper.data.ownerId,
          cancelNotifyDate: wrapper.data.cancelNotifyDate,
          serviceEndDate: wrapper.data.serviceEndDate,
          cancelAllProducts: wrapper.data.cancelAllProducts,
          products: {
            //start names of products to be cancelled with 'cancel' followed by productName
            cancelAvaTax: wrapper.data.cancelAvaTax,
            cancelGlobal: wrapper.data.cancelGlobal,
            cancelReturns: wrapper.data.cancelReturns,
            cancelSST: wrapper.data.cancelSST,
            cancelCertCapture: wrapper.data.cancelCertCapture,
            cancelGoldPremiumSupport: wrapper.data.cancelGoldPremiumSupport,
            cancelSandbox: wrapper.data.cancelSandbox,
            cancelExcise: wrapper.data.cancelExcise,
            cancelTaxRates: wrapper.data.cancelTaxRates,
            cancelMatrixMaster: wrapper.data.cancelMatrixMaster,
            cancelLandedCost: wrapper.data.cancelLandedCost,
            cancelOther: wrapper.data.cancelOther,
            cancelTaxServices: wrapper.data.cancelTaxServices,
            cancelTrustFile: wrapper.data.cancelTrustFile,
            cancelEMEAProducts: wrapper.data.cancelEMEAProducts,
          },
        },
      };
    },
  },
  productSummary: {
    keyCompare: (query, wrapper) => {
      const queryWords = query.split(' ');
      /*
              Here we are constructing a regex that will look like 
              /^(?=.*\bqueryWord1\b)(?=.*\bqueryWord2\b).*$/i
              The regex will try to find a match in a given string(wrapper.data.feature.name)
              for each word in the queryWords array.
              */
      var regexpStr =
        '^' + queryWords.map((word) => `(?=.*\\b${word}\\b)`).join('') + '.*$';
      var regexp = new RegExp(regexpStr, 'i');
      return (
        query === wrapper.data.id ||
        query.split(':')[1] === wrapper.data.id ||
        query === wrapper.data.cpqId ||
        query === wrapper.data.feature.id ||
        query.split(':')[1] === wrapper.data.feature.id ||
        query.split(':')[1] === wrapper.data.feature.name ||
        wrapper.data.feature.name.match(regexp)
      );
    },
    createLink: (wrapper) => {
      return {
        type: 'productLink',
        data: wrapper.data,
      };
    },
    //
    getCreateCardFunction: (wrapper) => {
      return (dispatch) => {
        // DEPRECATED: getCustomerIds functionality removed - setting empty customerInfo
        wrapper.data.customerInfo = [];
        finishedLoadingNewTopCard(dispatch, {
          type: 'productCard',
          data: wrapper.data,
        });
      };
    },
  },
  businessLicensesSummary: {
    keyCompare: (query, wrapper) => {
      return (
        query === wrapper.data.id ||
        query === `business-licenses:${wrapper.data.BLAccountID}`
      );
    },
    createLink: (wrapper) => {
      if (wrapper.data && wrapper.data.id && wrapper.data.deliverySystem) {
        return {
          type: 'deliverySystemLink',
          data: {
            customer: {
              id: wrapper.data.customerAccount
                ? wrapper.data.customerAccount.id
                : 'No customer found',
              name: wrapper.data.customerAccount
                ? wrapper.data.customerAccount.name
                : 'No customer found',
            },
            id: wrapper.data.id,
            deliverySystem: wrapper.data.deliverySystem,
          },
        };
      } else {
        return false;
      }
    },
    getCreateCardFunction: (wrapper) => {
      return (dispatch) =>
        finishedLoadingNewTopCard(dispatch, {
          type: 'businessLicensesCard',
          data: wrapper.data,
        });
    },
  },
};

// DEPRECATED: This function has been deprecated and is no longer used
// The functionality to fetch customer IDs for products has been removed
// to improve performance and simplify the codebase
// function getCustomerIds(product) {
//   const featureDetailId = product.featureDetailId
//     ? product.featureDetailId
//     : product.id;
//   const featureDetailIdUrl = `${baseUrl}/business-activity/customer/${featureDetailId}`;

//   return axios
//     .get(featureDetailIdUrl, {
//       // headers: { Authorization: authHeader },
//     })
//     .then((res) => {
//       product.customerInfo = res.data.data;
//       return product;
//     });
// }
function isAuthorizedToSeeCancelledProducts() {
  return axios
    .get(`${baseUrl}/default/isAuthorized/billing`)
    .then((res) => {
      if (res.data && res.data.isAuthorized) {
        return true;
      } else {
        return false;
      }
    })
    .catch((ex) => {
      // console.error(`unable to api request:`, ex.message);
      return false;
    });
  // const roles = auth.split(' ')[0] === 'AvalaraSharedAuth' ? [] : jwtDecode(auth).roles;
  // if (!roles) return false;
  // const authorizedRoles = ['SG-FIN-APPINT-Billing', 'SG-BiztechOps'];
  // return authorizedRoles.some((role) => roles.indexOf(role) >= 0);
}

const mapperToBiztechProducts = {
  AvaTax: 'Avalara AvaTax',
  Global: 'Avalara AvaTax Global',
  Returns: 'Avalara Returns',
  SST: 'Avalara Returns - SST',
  CertCapture: 'Avalara CertCapture',
  GoldPremiumSupport: 'Additional Fees - Professional Support',
  Sandbox: 'AvaTax Calc Sandbox',
  Excise: 'Avalara Excise',
  TaxRates: 'Avalara TaxRates',
  MatrixMaster: 'Avalara MatrixMaster',
  LandedCost: 'Avalara LandedCost',
  TaxServices: 'Avalara Professional Services',
  TrustFile: 'Avalara TrustFile',
  EMEAProducts: 'EMEA',
};

function getCancellationProducts(url, caseInfo) {
  if (!caseInfo) {
    return Promise.resolve({
      mappedProducts: [],
      comment: '',
      lastModifiedBy: '',
    });
  }
  const caseUrl = `${url}/${caseInfo}`;
  return axios
    .get(caseUrl)
    .then((res) => {
      const c = res.data.data;
      let productsToBeCancelled = [],
        comment,
        lastModifiedBy;
      for (let key in c) {
        if (key.startsWith('cancel')) {
          //cancelAllProducts and cancelOther to be manually handled by Cancellation Team
          if (
            c[key] &&
            key !== 'cancelNotifyDate' &&
            key !== 'cancelAllProducts' &&
            key !== 'cancelOther'
          ) {
            productsToBeCancelled.push(key.substring(6));
          }
          if (key === 'cancelOther' && c[key]) {
            //add to comments when comment is mentioned in cancelOther
            comment = c[key];
          }
        }
        if (key === 'lastModifiedBy') {
          lastModifiedBy = c[key];
        }
      }
      return { productsToBeCancelled, comment, lastModifiedBy };
    })
    .then((cancellationDetails) => {
      const mappedProducts = cancellationDetails.productsToBeCancelled.map(
        (product) => mapperToBiztechProducts[product]
      );
      return {
        mappedProducts,
        comment: cancellationDetails.comment,
        lastModifiedBy: cancellationDetails.lastModifiedBy,
      };
    })
    .catch((ex) => {
      // console.error(`unable to api request: ${url}`, ex.message, ex.stack);
    });
}

function getDeliverySystemDataSubscriptions(deliverySystemAccounts) {
  let deliverySystemInfo = {
    avatax: { path: 'avatax' },
    avataxSandbox: { path: 'avatax-sandbox' },
    // avataxTrustfile: { path: 'avatax-trustfile' },
    // 'business-licenses': { path: 'business-licenses' },
    // itemClassification: { path: 'item-classification' },
  };

  return Promise.all(
    deliverySystemAccounts.map((dsa) => {
      if (!deliverySystemInfo[dsa.subtype]) {
        // mm we must of added a new delevery system without updating the above deliverySystemInfo object
        return Promise.resolve([]);
      }
      return queryComponent(
        `${baseUrl}/delivery/${
          deliverySystemInfo[dsa.subtype].path
        }/search?query=${dsa.id}`
      );
    })
  ).then((res) => {
    // This logic looks complicated but I am really just changing the shape and format of some data.
    // The Promise.all returns an item for each delivery system with a bunch of data. The one piece of data that we want is the list of subscriptions.
    // So we have one map for each delevery system and another map for each subscription of that the delevery system has and a reduce to flatten it into one array.
    // In the future we might want to edit this so we have more information from diffrent delevery systems.
    // Currently most delvery systems currently do not have an api that returns any data.
    // Index by subtype rather than array position: deliverySystemAccounts (and therefore res)
    // is not guaranteed to list the avatax account before the avataxSandbox account.
    const avataxAndSandboxSubscriptions = [];
    deliverySystemAccounts.forEach((dsa, i) => {
      if (dsa.subtype === 'avatax') {
        avataxAndSandboxSubscriptions[0] = res[i]?.[0]?.data?.details?.subscriptions;
      } else if (dsa.subtype === 'avataxSandbox') {
        avataxAndSandboxSubscriptions[1] = res[i]?.[0]?.data?.details?.subscriptions;
      }
    });
    return avataxAndSandboxSubscriptions;
  });
}

// function getUsageGraphQLData(query) {
//   const configObj =
//     !process.env.REACT_APP_ENV || process.env.REACT_APP_ENV === 'development'
//       ? { headers: { Authorization: 'Bearer ' + getJwt() } }
//       : { credentials: 'include' };

//   const graphQLClient = new GraphQLClient(
//     `${baseUrl}/usage/graphql`,
//     configObj
//   );

//   return graphQLClient
//     .request(UsageQuery, { customerAccountId: query })
//     .catch(() => {
//       // console.warn('failed to get graphQL results');
//       return {};
//     });
// }

// const UsageQuery = `
// query ($customerAccountId: String) {
//   getInvoiceOwningCustomerAccount(customerAccountId: $customerAccountId) {
//     unitsOfMeasure {
//       customerIsInLintForConsumptionDays
//       unitOfMeasure
//       showUpgrade
//       unitsConsumedInThisTermForThisUoM
//       creditsConsumedInThisTermForThisUoM
//       overageInThisTermForThisUoM
//       creditsRemainingInThisTermForThisUoM
//       percentCreditsConsumedInThisTermForThisUoM
//       percentCreditsRemainingInThisTermForThisUoM
//       ratePlanOwningCustomerAccounts {
//         creditsRemainingInThisTermForThisRatePlan
//         unitsConsumedInThisTermForThisRatePlan
//         overageInThisTermForThisRatePlan
//         percentCreditsConsumedInThisTermForThisRatePlan
//         ratingPlanInformation {
//           featureDetail {
//             id
//             feature {
//               name
//               productName
//             }
//             includedUnits
//           }
//           accessStartDate
//           termStartDate
//           termEndDate
//           ratingPeriodLength
//           renewalDate
//           daysRemaining
//           termLength
//         }
//         periodSummaryByInvoice {
//           startDate
//           endDate
//           invoiceId
//           consumedUnits
//           ratedUnits
//           extendedAmount
//         }
//       }
//     }
//   }
// }`;
